import React, { useEffect, useState, useRef } from "react";
import backgroundimg from "./../image/banner.png";
import { Helmet } from "react-helmet";
import { useStateValue } from '../context/StateProvider';
import { motion } from 'framer-motion';
import Innovation from './../image/Innovation.png'
import Collabration from './../image/Collabration.png'
import Excellence from './../image/Excellence.png'
import Sustainability from './../image/Sustainability.png'
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";

const Aboutus = () => {
  const [{ Company }] = useStateValue();
  const scrollRef = useRef(null);
  const [showButtons, setShowButtons] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setShowButtons(false); // Hide buttons on small screens
      } else {
        setShowButtons(true); // Show buttons on larger screens
      }
    };

    handleResize(); // Initial check on load
    window.addEventListener('resize', handleResize); // Listen for window resize

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const autoScroll = setInterval(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
      }
    }, 3000); // Change the interval time as needed (3 seconds in this example)

    return () => clearInterval(autoScroll); // Clean up the interval on unmount
  }, []);

  const values = [
    {
      title: "Innovation",
      description:
        "We are committed to pushing the boundaries of technology, consistently developing creative and cutting-edge solutions that shape the future of businesses.",
      image: Innovation,
    },
    {
      title: "Collaboration",
      description:
        "We believe in fostering strong, trust-based partnerships with our clients, working together to achieve shared goals and deliver lasting impact.",
      image: Collabration,
    },
    {
      title: "Excellence",
      description:
        "Our team of certified professionals is dedicated to delivering the highest quality solutions, ensuring precision, reliability, and measurable results in everything we do.",
      image: Excellence,
    },
    {
      title: "Sustainability",
      description:
        "We focus on creating solutions that not only address immediate challenges but also enable long-term growth, resilience, and industry leadership for our clients.",
      image: Sustainability,
    },
  ];

  return (
    <div className='w-full h-auto bg-white flex flex-col items-center  justify-center lg:mt-20 mt-0'>
      <Helmet>
        <title>About - Nexify InfoSystems </title>
        <meta
          name="description"
          content="Discover how Nexify InfoSystems is redefining IT consulting with expertise in AI, Cloud Computing, Cybersecurity, and more. Our vision is to create impactful digital transformations for businesses worldwide."
        />
        <meta
          name="keywords"
          content="Nexify InfoSystems, IT consulting, Digital Transformation, Automation, AI, Cloud Computing, Cybersecurity, Data Engineering, Technology Consulting, Business Innovation"
        />
      </Helmet>

       <div
        className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${backgroundimg})` }}
      >
        <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
          <div
            className="opacity-0 translate-y-10 animate-slideUp bg-[#0e55a8] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14 border border-white/20 rounded-lg relative"
            style={{
              animation: "slideUp 1s ease-in-out forwards",
              animationDelay: "2s",
            }}
          >
            {/* 🔵 Dot Pattern Overlay Inside Box */}
            <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(255,255,255,0.2)_1px,_transparent_1px)] bg-[size:6px_6px] opacity-50 pointer-events-none rounded-lg"></div>
      
            <h1 className="lg:text-[66px] text-[43px] font-semibold mb-2 lg:whitespace-nowrap">
              About Nexify
            </h1>
            <h2 className="lg:text-[40px] text-[35px] text-[#efefef]">
              Your Success. Secured.
            </h2>
          </div>
        </div>
      </div>
      <div className="bg-white p-6 w-full max-w-[1320px] gap-10 mb-10 lg:mt-10 mt-5">
        <div className="flex-1">
          <h3 className="text-[30px] leading-[1.25] font-[700] text-[#363638] mb-[1em]">Revolutionizing Business Growth and Innovation with Nexify InfoSystems</h3>
          <p className="text-[#6d6d70] mb-4 font-[400] text-[16px] leading-[1.8] lg:text-justify text-left">
            At Nexify InfoSystems, we go beyond the conventional definitions of consulting and staffing—we are the architects of transformation, shaping the future of businesses with innovation, precision, and impact. Our dedicated team of industry experts and certified professionals is committed to delivering cutting-edge IT solutions that span a broad spectrum of capabilities, including Automation, Artificial Intelligence, Data Engineering, Cloud Computing, Cybersecurity, Technology Consulting, and Advanced Talent Screening. With a foundation rooted in excellence and a relentless drive for innovation, we develop bespoke strategies designed to help businesses realize their full potential. Whether navigating complex challenges or seizing emerging opportunities, our approach ensures that every solution is aligned with your unique vision and objectives.
          </p>
          <p className="text-[#6d6d70] mb-4 font-[400] text-[16px] leading-[1.8] lg:text-justify text-left">
            At Nexify, we believe in building lasting relationships anchored in trust, collaboration, and measurable impact. We don’t just address immediate needs or challenges; we create sustainable pathways to growth and success. By turning complexity into opportunity, we deliver solutions that not only solve problems but also position businesses for long-term resilience and leadership in their industries.
          </p>
          <p className="text-[#6d6d70] mb-4 font-[400] text-[16px] leading-[1.8] lg:text-justify text-left">
            Our partnerships represent a legacy of success, a testament to our unwavering commitment to delivering enduring value. Together, let’s transform your aspirations into actionable outcomes and redefine what’s possible for your organization. With Nexify InfoSystems, the future isn’t just anticipated—it’s designed.
          </p>
        </div>
        <div className="container mx-auto px-4 py-2 lg:mt-5 mt-16 mb-10 ">
          <h2 className="text-[#0e55a8] text-[30px] lg:text-[40px] font-[700] text-center mb-8">
            Our CORE Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="flex flex-col items-center text-left">
                <img src={value.image} alt={value.title} className="w-32 h-32 mb-4" />
                <h4 className="text-[24px] font-[500] text-[#ff9416] w-full">{value.title}</h4>
                <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.6] w-full mt-2">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="relative w-full max-w-[1400px] mt-10 lg:mt-0 lg:p-0 p-4">
          <h2 className="text-[#0e55a8] text-[30px] lg:text-[40px] font-[700] text-center mb-5">
            Our Trusted Partners
          </h2>
          <div
            ref={scrollRef}
            className="lg:w-full flex items-center justify-start lg:justify-center gap-2 lg:gap-28 lg:py-6 overflow-x-auto scrollbar-none md:overflow-x-scroll"
          >
            {Company && Company.length > 0 ? (
              Company.map((brand) => (
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  key={brand.id}
                  className="flex flex-col items-center bg-white p-2"
                >
                  <div className="w-24 h-24 md:w-32 md:h-32 lg:w-32 lg:h-32 overflow-hidden">
                    <img
                      src={brand.imageurl}
                      alt={brand.title}
                      className="w-full h-full object-contain"
                    />
                  </div>
                </motion.div>
              ))
            ) : (
              <p>No Partner available</p>
            )}
          </div>
        </div>
         <div className="bg-white flex flex-col md:flex-row lg:p-12 p-6 w-full max-w-[1320px] lg:text-center md:shadow-lg md:rounded-lg gap-20 lg:mb-10 lg:mt-20 mt-10 justify-center items-center">
                 {/* Left Side */}
                 <div className="lg:mb-2 md:mb-0 lg:text-center">
                   <h3 className="lg:text-3xl text-xl font-[500] text-black mt-2">Follow us for updates at #NexifyCareers</h3>
                 </div>
       
                 {/* Social Media Icons */}
                 <div className="flex lg:justify-center lg:items-center lg:gap-6 gap-3 lg:mt-4 mt-[-40px] md:mt-0 ">
       
                   <a
                     href="https://www.linkedin.com/company/nexify-infosystems-llc"
                     target="_blank"
                     rel="noopener noreferrer"
                     className="flex items-center justify-center w-14 h-14 rounded-md bg-[#005eb8] text-white text-2xl"
                   >
                     <FaLinkedinIn />
                   </a>
                   <a
                     href="https://www.instagram.com/nexify_infosystems?igsh=MXZkN3loYWtiYmVpdw=="
                     target="_blank"
                     rel="noopener noreferrer"
                     className="flex items-center justify-center w-14 h-14 rounded-md bg-[#005eb8] text-white text-2xl"
                   >
                     <FaInstagram />
                   </a>
                 </div>
               </div>
      </div>

    </div>
  );
};

export default Aboutus;
